var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Question',{ref:"questionContentRef",attrs:{"isMSDCustom":"","currentQuestion":_vm.currentQuestion,"allQuestions":_vm.allQuestions,"currentStep":_vm.currentStep},on:{"selectedChange":_vm.handleSelectedChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }